var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 94 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.855 22.933a21.828 21.828 0 006.486 15.51A22.252 22.252 0 0047 44.867c5.873 0 11.505-2.311 15.658-6.424a21.828 21.828 0 006.486-15.51 21.828 21.828 0 00-6.486-15.509A22.253 22.253 0 0047 1 22.253 22.253 0 0031.34 7.424a21.828 21.828 0 00-6.486 15.51v0zM5.875 95h82.212M5.875 95c0-10.803 4.333-21.164 12.045-28.803 7.713-7.639 18.173-11.93 29.08-11.93s21.367 4.291 29.08 11.93c7.712 7.64 12.045 18 12.045 28.803",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgUser;